import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-albama-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./albama-state-form.component.html",
  styleUrl: "./albama-state-form.component.scss",
})
export class AlbamaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
